<template>
    <div id="login" :style="'background:url('+backImg+');background-size: 100% 100%;'">
        <div class="box">
            <p class="info">重置密码</p>
            <el-form :model="form" class="form">
                <el-form-item>
                    <el-input v-model="form.mobile" placeholder="请输入手机号">
                        <i slot="prefix" class="el-input__icon el-icon-mobile"></i>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="form.password" placeholder="请输入密码" type='password'>
                        <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="form.password_confirm" placeholder="确认密码" type='password'>
                        <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="form.code" placeholder="请输入手机验证码">
                        <i slot="prefix" class="el-input__icon el-icon-postcard"></i>
                        <template slot="append">
                            <el-button style="background-color: #409eff;color: white;" @click="getCode" type="primary" :disabled='countDown'>{{getText}}</el-button>
                        </template>
                    </el-input>
                </el-form-item>
            </el-form>
            <el-button type="primary" style="width:200px" @click="changePwd">提交</el-button>
            <p class="forget" @click="toLogin">登录</p>
        </div>
    </div>
</template>

<script>
import { getcode, repassword, getback } from '@/api/login'
export default {
    name: "loginIn",
    data() {
        return {
            form: {
                name: '',
                pwd: ''
            },
            getText: '获取验证码',
            totalTime: 60,
            countDown: false,
            backImg: ''
        }
    },
    created() {
        this.getBackImg()
    },
    methods: {
        toLogin() {
            this.$router.push({
                name: 'login',
            })
        },
        getBackImg() {
            getback().then(res => {
                this.backImg = res.data.shop_theme_background
            })
        },
        getCode() {
            var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
            if (!myreg.test(this.form.mobile)) {
                this.$message({
                    message: '手机号格式不正确',
                    type: "error",
                });
                return false;
            }
            getcode({
                mobile: this.form.mobile,
                event: 'resetpwd',
                type: 1,
            }).then(res => {
                if (res.code == 1) {
                    this.$message({
                        message: '发送成功',
                        type: "success",
                    });
                    this.haveCode()
                } else {
                    this.$message({
                        message: res.message,
                        type: "error",
                    });
                }
            })

        },
        haveCode() {
            if (this.getText == '重新发送验证码' || this.getText == '获取验证码') {
                this.countDown = true;//点击之后设置按钮不可取
                this.getText = this.totalTime + "s后重新发送";//按钮内文本
                let clock = window.setInterval(() => {
                    this.totalTime--;
                    this.getText = this.totalTime + "s后重新发送";
                    if (this.totalTime < 0) {
                        window.clearInterval(clock);
                        this.getText = "重新发送验证码";
                        this.totalTime = 60;
                        this.countDown = false; //这里重新开启
                    }
                }, 1000);
            }
        },
        changePwd() {
            let data = {
                mobile: this.form.mobile,
                password: this.form.password,
                password_confirm: this.form.password_confirm,
                code: this.form.code,
            }
            repassword(data).then(res => {
                if (res.code == 1) {
                    this.$message({
                        message: '修改成功,前往登录',
                        type: "success",
                    });
                    this.$router.push({
                        name: 'login'
                    })
                } else {
                    this.$message({
                        message: res.message,
                        type: "error",
                    });
                }
            })
        },
    }
};
</script>

<style lang="scss" scoped>
#login {
    width: 100%;
    height: 100vh;
    // background: url("https://img0.baidu.com/it/u=4048401711,794461287&fm=253&fmt=auto&app=138&f=JPEG?w=889&h=500")
    //     no-repeat;
    background-size: 100% 100%;
    position: relative;
    .box {
        width: 450px;
        height: 500px;
        border-radius: 20px;
        background: rgba(0, 0, 0, 0.5);
        text-align: left;
        padding: 30px;
        color: white;
        position: absolute;
        right: 10%;
        bottom: 20%;
        .title {
            font-size: 35px;
        }
        .info {
            font-size: 18px;
            margin-top: 20px;
        }
        .form {
            margin-top: 20px;
        }
        .forget {
            color: white;
            font-size: 13px;
            position: absolute;
            left: 30px;
            bottom: 30px;
        }
    }
}
</style>
